import type {AgentProfile} from '../agent-profile'
import {DefaultTrailingVisual} from './DefaultTrailingVisual'

/**
 * Profile overrides for the Copilot Code Review agent (copilot-pr-reviews).
 *
 * - No chat input (sessions are read-only)
 * - No stop button or active session controls
 */
export const CODE_REVIEW_PROFILE: Partial<AgentProfile> = {
  slug: 'copilot-pr-reviews',
  displayName: 'Copilot Code Review',

  slots: {
    LeadingIcon: null,
    ChatInput: null,
    EmptyState: null,
    TrailingVisual: DefaultTrailingVisual,
  },
}
